import { render } from "./WalkingInstructionList.vue?vue&type=template&id=927212a2&scoped=true"
import script from "./WalkingInstructionList.vue?vue&type=script&lang=js"
export * from "./WalkingInstructionList.vue?vue&type=script&lang=js"

import "./WalkingInstructionList.vue?vue&type=style&index=0&id=927212a2&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-927212a2"]])

export default __exports__